
import React from 'react';
import moment from 'moment';

const ModernCorporateTemplate = ({ packageData, user }) => {
    if (!packageData?.package) return <div>Loading...</div>;
    const { package: pkg } = packageData;

    // --- Helper for Section Titles ---
    const SectionTitle = ({ children }) => (
        <h3 style={{ fontSize: '18px', color: '#003366', fontWeight: 'bold', borderBottom: '2px solid #003366', paddingBottom: '8px', textTransform: 'uppercase' }}>
            {children}
        </h3>
    );
    
    // --- Helper for Tables ---
    const StyledTable = ({ children }) => (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px', marginTop: '15px' }}>
            {children}
        </table>
    );
    
    const thStyle = { backgroundColor: '#f2f2f2', padding: '10px', border: '1px solid #ddd', textAlign: 'left' };
    const tdStyle = { padding: '10px', border: '1px solid #ddd' };


    return (
        <div style={{ fontFamily: "'Roboto', 'Segoe UI', sans-serif", fontSize: '14px', color: '#212529', lineHeight: '1.5', backgroundColor: '#fff' }}>
            {/* Header */}
            <div style={{ backgroundColor: '#003366', color: 'white', padding: '25px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                    <h1 style={{ margin: 0, fontSize: '32px', fontWeight: 'bold', letterSpacing: '1px', color: '#ffff' }}>{pkg.packageName}</h1>
                    <p style={{ margin: '5px 0 0', opacity: 0.9 }}>{pkg.destinationsCover}</p>
                </div>
                {user?.logo && <img src={user.logo} alt="Logo" style={{ maxHeight: '60px', background: 'white', padding: '5px', borderRadius: '4px' }} />}
            </div>

            {/* Main Content Area */}
            <div style={{ display: 'flex', padding: '30px' }}>
                {/* Left Column (Main Details) */}
                <div style={{ flex: 2, paddingRight: '30px' }}>
                    {/* Overview */}
                    <div style={{ marginBottom: '30px' }}>
                        <SectionTitle>Trip Overview</SectionTitle>
                        <p style={{ marginTop: '15px' }}>{pkg.description}</p>
                    </div>

                    {/* Itinerary */}
                    {packageData.itineraries?.length > 0 && (
                        <div style={{ marginBottom: '30px' }}>
                            <SectionTitle>Itinerary Details</SectionTitle>
                            {packageData.itineraries.slice().sort((a, b) => new Date(a.date) - new Date(b.date)).map((item, index) => (
                                <div key={index} style={{ padding: '15px', border: '1px solid #e9ecef', borderRadius: '4px', marginTop: '15px' }}>
                                    <h5 style={{ fontWeight: 'bold', margin: 0 }}>{moment(item.date).format("dddd, MMMM D")} - {item.title}</h5>
                                    <p style={{ color: '#6c757d', margin: '5px 0 10px' }}>Location: {item.location}</p>
                                    <p style={{ margin: 0 }}>{item.description}</p>
                                </div>
                            ))}
                        </div>
                    )}
                     
                     {/* Flight Details Table */}
                     {packageData.flightBookings?.length > 0 && (
                         <div style={{ marginBottom: '30px' }}>
                            <SectionTitle>Flights</SectionTitle>
                             <StyledTable>
                                 <thead><tr><th style={thStyle}>Airline</th><th style={thStyle}>From</th><th style={thStyle}>To</th><th style={thStyle}>Departure</th><th style={thStyle}>Arrival</th></tr></thead>
                                 <tbody>
                                     {packageData.flightBookings.map((f, i) => <tr key={i}><td style={tdStyle}>{f.airline} {f.flightNumber}</td><td style={tdStyle}>{f.departureCity}</td><td style={tdStyle}>{f.arrivalCity}</td><td style={tdStyle}>{moment(f.departureDateTime).format('DD MMM, HH:mm')}</td><td style={tdStyle}>{moment(f.arrivalDateTime).format('DD MMM, HH:mm')}</td></tr>)}
                                 </tbody>
                             </StyledTable>
                         </div>
                     )}

                     {/* --- HOTEL DETAILS --- */}
                     {packageData.hotelBookings?.length > 0 && (
                         <div style={{ marginBottom: '30px' }}>
                            <SectionTitle>Accommodations</SectionTitle>
                             <StyledTable>
                                 <thead><tr><th style={thStyle}>City</th><th style={thStyle}>Hotel</th><th style={thStyle}>Check-In</th><th style={thStyle}>Check-Out</th><th style={thStyle}>Room Type</th></tr></thead>
                                 <tbody>
                                     {packageData.hotelBookings.map((h, i) => <tr key={i}><td style={tdStyle}>{h.city}</td><td style={tdStyle}>{h.hotelName}</td><td style={tdStyle}>{moment(h.checkInDate).format('DD MMM YYYY')}</td><td style={tdStyle}>{moment(h.checkOutDate).format('DD MMM YYYY')}</td><td style={tdStyle}>{h.roomType}</td></tr>)}
                                 </tbody>
                             </StyledTable>
                         </div>
                     )}

                     {/* --- SIGHTSEEING DETAILS --- */}
                     {packageData.sightSeeings?.length > 0 && (
                         <div style={{ marginBottom: '30px' }}>
                            <SectionTitle>Sightseeing</SectionTitle>
                             <StyledTable>
                                 <thead><tr><th style={thStyle}>Date</th><th style={thStyle}>Attraction</th><th style={thStyle}>Location</th></tr></thead>
                                 <tbody>
                                     {packageData.sightSeeings.map((s, i) => <tr key={i}><td style={tdStyle}>{moment(s.date).format('DD MMM YYYY')}</td><td style={tdStyle}>{s.sightseeingName}</td><td style={tdStyle}>{s.destination}</td></tr>)}
                                 </tbody>
                             </StyledTable>
                         </div>
                     )}

                     {/* --- TRANSFER DETAILS --- */}
                     {packageData.transfers?.length > 0 && (
                         <div style={{ marginBottom: '30px' }}>
                            <SectionTitle>Transfers</SectionTitle>
                             <StyledTable>
                                 <thead><tr><th style={thStyle}>Date & Time</th><th style={thStyle}>From</th><th style={thStyle}>To</th><th style={thStyle}>Vehicle</th></tr></thead>
                                 <tbody>
                                     {packageData.transfers.map((t, i) => <tr key={i}><td style={tdStyle}>{moment(t.date).format('DD MMM')} at {t.pickupTime}</td><td style={tdStyle}>{t.fromLocation}</td><td style={tdStyle}>{t.toLocation}</td><td style={tdStyle}>{t.vehicleDetails}</td></tr>)}
                                 </tbody>
                             </StyledTable>
                         </div>
                     )}
                     
                     {/* --- TERMS & CONDITIONS --- */}
                     {packageData.termsandConditions?.length > 0 && (
                         <div style={{ marginBottom: '30px' }}>
                             <SectionTitle>Terms & Conditions</SectionTitle>
                             {packageData.termsandConditions.map((term, i) => (
                                 <div key={i} style={{ marginTop: '15px' }}>
                                     <h5 style={{ fontWeight: 'bold' }}>{term.title}</h5>
                                     <p style={{ fontSize: '13px', color: '#555' }}>{term.description}</p>
                                 </div>
                             ))}
                         </div>
                     )}
                </div>

                {/* Right Column (Sidebar) */}
                <div style={{ flex: 1, backgroundColor: '#f8f9fa', padding: '20px', borderRadius: '4px', alignSelf: 'flex-start' }}>
                    <h4 style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '20px', textTransform: 'uppercase' }}>Package at a Glance</h4>
                    <img src={pkg.imageSrc} alt="Destination" style={{ width: '100%', borderRadius: '4px', marginBottom: '20px' }} />
                    <div style={{ marginBottom: '15px' }}><strong>Duration:</strong> {pkg.duration}</div>
                    <div style={{ marginBottom: '15px' }}><strong>Start Date:</strong> {moment(pkg.startedDate).format("MMMM Do, YYYY")}</div>
                    <div style={{ marginBottom: '25px' }}><strong>Price:</strong> <span style={{ fontWeight: 'bold', color: '#003366', fontSize: '18px' }}>{pkg.price} {pkg.currency}</span></div>

                    {packageData.includes?.length > 0 && (
                        <div style={{ marginBottom: '25px' }}>
                            <h5 style={{ fontSize: '15px', fontWeight: 'bold', textTransform: 'uppercase' }}>Includes</h5>
                            <ul style={{ listStyle: 'none', padding: 0, marginTop: '10px' }}>
                                {packageData.includes.map((item, i) => <li key={i} style={{ paddingLeft: '20px', textIndent: '-20px', marginBottom: '5px' }}>✔️ {item.description}</li>)}
                            </ul>
                        </div>
                    )}
                    {packageData.excludes?.length > 0 && (
                        <div>
                            <h5 style={{ fontSize: '15px', fontWeight: 'bold', textTransform: 'uppercase' }}>Excludes</h5>
                            <ul style={{ listStyle: 'none', padding: 0, marginTop: '10px' }}>
                                {packageData.excludes.map((item, i) => <li key={i} style={{ paddingLeft: '20px', textIndent: '-20px', marginBottom: '5px' }}>❌ {item.description}</li>)}
                            </ul>
                        </div>
                    )}
                </div>
            </div>
             {/* Footer */}
             <footer style={{ padding: '20px 30px', backgroundColor: '#f8f9fa', borderTop: '1px solid #ddd', textAlign: 'center', fontSize: '12px', color: '#666' }}>
                <p>Quotation prepared by {user?.companyName || 'our team'}. For inquiries, please contact {pkg.contactEmail}.</p>
            </footer>
        </div>
    );
};

export default ModernCorporateTemplate;